import { useQuery } from '@tanstack/react-query';
import apiClient from 'services/apiClient';
import useAuth from 'hooks/useAuth';
import { useRecoilValue } from 'recoil';
import rhpLinkAccountAtom from 'recoil/account/rhpLinkAccount';

export const RHP_EVENTS_KEY = ['account', 'events'];
const FIFTEEN_MINUTES = 15 * 60 * 1000;

const useRHPEvents = () => {
    const { isAuthenticated, accountLoaded } = useAuth();
    const { Username } = useRecoilValue(rhpLinkAccountAtom);
    return useQuery(
        RHP_EVENTS_KEY,
        () => apiClient.get('/Account/RHPEvents').then(r => r.data),
        {
            staleTime: FIFTEEN_MINUTES,
            refetchInterval: FIFTEEN_MINUTES,
            enabled: isAuthenticated && accountLoaded && !!Username,
        }
    );
};

export default useRHPEvents;
